import { InjectionToken } from '@angular/core';

const JOURNEY_METADATA_SERVICE_TOKEN = new InjectionToken('Journey Metadata Service');
/**
 * The base class which will be implemented by the client application
 *
 * The client application will override the method which will send the configuration for a particular view or it's subset for consumption within that view's component
 */
class JourneyMetadataService {
}

/**
 * Generated bundle index. Do not edit.
 */

export { JOURNEY_METADATA_SERVICE_TOKEN, JourneyMetadataService };
